import { render, staticRenderFns } from "./WholesalerList.vue?vue&type=template&id=5e30f7c7&"
import script from "./WholesalerList.vue?vue&type=script&lang=js&"
export * from "./WholesalerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports